import React from "react";
import { Link } from "react-router-dom";

export default function Footer({ logoUrl = "/images/logo.png" }) {
  const socialLinks = [
    {
      href: "https://www.facebook.com/omovacarbonfiber",
      icon: "/icons/Facebook.webp",
      alt: "Facebook",
      handle: "@omovacarbonfiber",
    },
    {
      href: "https://www.instagram.com/omovacarbonfiber/",
      icon: "/icons/IG.webp",
      alt: "Instagram",
      handle: "@omovacarbonfiber",
    },
    {
      href: "https://www.tiktok.com/@omovacarbonfiber",
      icon: "/icons/Tiktok.webp",
      alt: "TikTok",
      handle: "@omovacarbonfiber",
    },
  ];

  return (
    <footer className="bg-black text-[#d2d2d2]">
      <div className="mx-auto max-w-[1180px] px-5 py-6 md:px-8 md:py-8">
        <div className="grid grid-cols-2 gap-x-8 gap-y-4 text-center md:grid-cols-[1.2fr_1fr_1fr_1fr_1fr] md:gap-x-10 md:gap-y-2 md:text-left">
          <div className="col-span-2 flex flex-col items-center md:col-span-1 md:items-start">
            <img
              src={logoUrl}
              alt="logo"
              className="h-auto w-36 object-contain md:w-48"
            />
            <p className="mt-2 max-w-[220px] text-xs leading-snug text-[#b6b6b6] md:mt-3 md:text-base md:leading-[1.3]">
              Fibra de carbono y resinas para todo México.
            </p>
          </div>

          <div className="space-y-0.5 text-sm md:space-y-1 md:text-lg">
            <h3 className="mb-1 text-xl font-bold uppercase tracking-wider text-primary-green md:mb-2 md:text-3xl">
              PRODUCTOS
            </h3>
            <Link to="/productos/FibraDeCarbono" className="block hover:text-white">
              Fibra de carbono
            </Link>
            <Link to="/productos/ResinaCatalizador" className="block hover:text-white">
              Resina
            </Link>
            <Link to="/productos/Flakes" className="block hover:text-white">
              Flakes
            </Link>
          </div>

          <div className="space-y-0.5 text-sm md:space-y-1 md:text-lg">
            <h3 className="mb-1 text-xl font-bold uppercase tracking-wider text-primary-green md:mb-2 md:text-3xl">
              EMPRESA
            </h3>
            <Link to="/nosotros" className="block hover:text-white">
              Nosotros
            </Link>
            <Link to="/contacto" className="block hover:text-white">
              Contacto
            </Link>
            <Link to="/preguntas-frecuentes" className="block hover:text-white">
              Preguntas frecuentes
            </Link>
          </div>

          <div className="space-y-0.5 text-sm md:space-y-1 md:text-lg">
            <h3 className="mb-1 text-xl font-bold uppercase tracking-wider text-primary-green md:mb-2 md:text-3xl">
              COMPRAR
            </h3>
            <Link to="/mayorista" className="block hover:text-white">
              Mayorista
            </Link>
            <Link to="/productos/FibraDeCarbono" className="block hover:text-white">
              Por metro
            </Link>
            <Link to="/ecommerce" className="block hover:text-white">
              Por medida
            </Link>
          </div>

          <div className="space-y-0.5 text-sm md:space-y-1 md:text-lg">
            <h3 className="mb-1 text-xl font-bold uppercase tracking-wider text-primary-green md:mb-2 md:text-3xl">
              POLÍTICAS
            </h3>
            <Link to="/terminosYCondiciones" className="block hover:text-white">
              Términos
            </Link>
            <Link to="/avisoDePrivacidad" className="block hover:text-white">
              Privacidad
            </Link>
            <Link to="/politicasDeCompra" className="block hover:text-white">
              Envíos
            </Link>
          </div>
        </div>

        <div className="mt-5 border-t border-[#3a3a3a] pt-3 md:mt-7 md:flex md:items-center md:justify-between md:pt-4">
          <p className="text-center text-xs text-[#8f8f8f] md:text-sm">
            © {new Date().getFullYear()} Omova Carbon Fiber · Hecho en México
          </p>

          <div className="mt-3 flex flex-col items-center gap-2 md:mt-0 md:flex-row md:items-center md:gap-4">
            <span className="text-[22px] font-bold uppercase tracking-wide text-primary-green md:text-[32px]">
              Síguenos
            </span>
            <div className="flex items-center gap-2 md:gap-3">
              {socialLinks.map((social) => (
                <a
                  key={social.alt}
                  href={social.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-1.5 bg-[#171717] px-2.5 py-1.5 text-[10px] font-semibold text-primary-green transition hover:text-white md:text-xs"
                >
                  <img src={social.icon} alt={social.alt} className="h-4 w-4 object-contain" />
                  <span>{social.handle}</span>
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
